module.exports = __webpack_public_path__ + "static/img/011.88d408b6.svg";